import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySections } from '../components/StorySections';
import { QualificationSection } from '../components/QualificationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FAQGuaranteeSection } from '../components/FAQGuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-bbq-dark font-sans text-gray-200 selection:bg-bbq-ember selection:text-white" data-id="element-279">
      <UrgencyBar data-id="element-280" />
      <main data-id="element-281">
        <HeroSection data-id="element-282" />
        <StorySections data-id="element-283" />
        <QualificationSection data-id="element-284" />
        <TestimonialsSection data-id="element-285" />
        <OfferSection data-id="element-286" />
        <PricingSection data-id="element-287" />
        <FAQGuaranteeSection data-id="element-288" />
        <ClosingSection data-id="element-289" />
      </main>
      <Footer data-id="element-290" />
      <RecentPurchaseToast data-id="element-291" />
    </div>;
}